import * as React from 'react'

import { Avatar } from '@factorialco/deprecated-design-system'
import { TeamsListItemFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  team?: TeamsListItemFragment
}

const TeamAvatar: React.FC<Props> = ({ team }) => {
  const avatar = team && team?.avatar

  return <Avatar size="s40" url={buildUrl(avatar)} label={team?.name ?? ''} />
}

export default TeamAvatar
